<template>
    <div class="rr-box">
        <ReumTextBox class="input-text rr-text" label="Sample Script" v-model="comp.info.text"></ReumTextBox>
        <button class="btn-send" :class="{ 'active':!!comp.info.text }" @click="comp.onSend"><i class="lar la-paper-plane"></i></button>
    </div>
    <div class="bar"><span>script list</span></div>
    <div class="sample-list">
        <template v-for="(irow, i) in comp.list" :key="i">
            <div class="sample-item" :class="{ 'modified':comp.modified.idx==irow.idx, 'selected':comp.selected.idx==irow.idx }">
                <div class="sample-body">
                    <span class="script" @click="comp.doShow(irow)">{{ irow.script }}</span>

                    <div class="pronunciation">
                        <ReumTextBox class="input-text rr-text" label="Scripts to be modified" v-model="comp.modified.script"></ReumTextBox>
                        <button class="btn-submit" @click="comp.doModify()"><i class="las la-save"></i></button>
                        <button class="btn-cancel" @click="comp.doDeselect()"><i class="las la-ban"></i></button>
                    </div>
                </div>
                <button type="button" class="btn-mod" @click="comp.doSelect(irow)"><i class="las la-pencil-alt"></i></button>
                <button type="button" class="btn-demod" @click="comp.doDeselect()"><i class="las la-times"></i></button>
                <button type="button" class="btn-del" @click="comp.doDelete(irow.idx)"><i class="lar la-trash-alt"></i></button>
            </div>
        </template>
    </div>


    <audio id="audioplayer" class="rr-voice" :src="comp.info.mergeURL"></audio>
    <audio id="audioplayer2" class="rr-voice" :src="comp.play.vpath"></audio>
</template>

<script>
import { reactive, onMounted } from "vue";
import axios from "axios";
import { useToast } from 'vue-toastification';
import { useRouter } from 'vue-router';
import ReumTextBox from "@/components/ReumLib/UI/ReumTextBox.vue";

export default {
    name: "List",
    components: {
        ReumTextBox
    },
    setup() {
        const toast  = useToast();
        const router = useRouter();
        const comp = reactive({
            audioplayer : null,
            info: {
                text:"",
                status: 0,
                chunks: [],
                mergeURL: null,
                source:null,
                base64: null,
                isnative:false,
            },
            rec_config: {
                audio: true,
                // {
                //     channelCount: 1,
                //     sampleRate: 16000,
                //     sampleSize: 16,
                //     volume: 1
                // },
                video:false
            },
            recorder : null,
            list:[], total:0,
            play: { idx:0, vpath:"" },
            selected: { idx:'', native:[], tester:[], control:[] },
            modified: { idx:'', script:'' },
            view : {
                show:'N',
                idx:'',
                phonemes:[],
                control:[],
                result:[],
                text: '',
            },

            gotStream: (mediaStream) => {
                console.info("gotStream");
                comp.info.status = 2;
                window.streamReference = mediaStream;
                comp.recorder = null;
                comp.recorder = new MediaRecorder(mediaStream);
                comp.recorder.start(100);
                comp.recorder.ondataavailable = comp.audioDataHandler;
            },
            onRecord: () => {
                console.info("Record");
                comp.info.status = 1;
                comp.info.chunks = [];
                navigator.mediaDevices.getUserMedia(comp.rec_config)
                .then(comp.gotStream)
                .catch(err => {
                    console.error(err.name + ": " + err.message)
                    toast.error(err.name + ": " + err.message)
                    comp.info.status = 0;
                });
            },
            onStop: () => {
                console.info("Stop");
                comp.info.status = 3;
                if (!window.streamReference) {
                    return;
                }
                window.streamReference.getAudioTracks().forEach(track => {
                    track.stop();
                });
                window.streamReference = null;

            },
            onSend: () => {
                let params = {
                    text:comp.info.text,
                }
                if( !params.text ){
                    toast.warning("스크립트를 입력하세요.")
                    return
                }
                axios.post("/ai/sample_script_add", params).then((res) => {
                    if(res.data.err == 0) {
                        comp.info.text = ""
                        toast.success("전송했습니다.");
                        comp.doSearch()
                    } else {
                        if( res.data.err_msg ) toast.error(res.data.err_msg);
                    }
                }).catch((err) => {
                    toast.error("연결에 오류가 있습니다. :: ", err);
                });
            },
            onSendVoice: () => {
                let params = {
                    idx: comp.selected.idx,
                    isnative: comp.info.isnative==true?'Y':'N',
                    raw:comp.info.base64
                }
                axios.post("/ai/voice_upload", params).then((res) => {
                    if(res.data.err == 0) {
                        comp.info.base64 = null
                        comp.info.mergeURL = null
                        toast.success("전송했습니다.");
                        comp.doSearchItem()
                    } else {
                        if( res.data.err_msg ) toast.error(res.data.err_msg);
                    }
                }).catch((err) => {
                    toast.error("연결에 오류가 있습니다. :: ", err);
                });
            },
            audioDataHandler(event){
                console.info("Push");
                comp.info.chunks.push(event.data);
                if(comp.info.status == 3) {
                    let mergeBlob = new Blob(comp.info.chunks,{type:'audio/wav; codecs=MS_PCM'})
                    comp.info.mergeURL = URL.createObjectURL(mergeBlob);

                    let reader = new FileReader();
                    reader.onload = function(event){
                        comp.info.base64 = event.target.result;
                    }; // data url!
                    comp.info.source = reader.readAsDataURL(mergeBlob);
                    comp.info.status = 0;
                }
            },
            onPlay:(o) => {
                if( o ){
                    comp.play.idx = o.idx
                    comp.play.vpath = o.vpath
                    let audioplayer = document.getElementById("audioplayer2")
                    setTimeout(() =>{
                        audioplayer.play();
                    }, 200)

                } else {
                    comp.play.idx = 0
                    comp.play.vpath = ""
                    // let audioplayer = document.getElementById("audioplayer")
                    setTimeout(() =>{
                        comp.audioplayer.play();
                    }, 200)
                }
            },

            doSearch: () => {
                let params = {
                    page : comp.page
                }
                axios.get("/ai/sample_list", { params:params }).then((res) => {
                    if( res.data.err == 0 ){
                        comp.list = res.data.list
                        comp.total = res.data.total
                    }
                })
            },

            doShow:(s)=>{
                let idx = s["idx"]
                router.push({ path:`/Scripts/View/${idx}` })
            },

            doSelect:(s)=>{
                comp.modified.idx = s.idx
                comp.modified.script = s.script
            },

            doDeleteItem:(idx)=>{
                let params = { idx:idx }
                if( confirm("해당 음성을 삭제하시겠습니까?") == true ){
                    axios.get("/ai/sample_voice_del", { params:params }).then((res) => {
                        if( res.data.err == 0 ){
                            comp.doSearchItem()
                        } else {
                            if( res.data.err_msg ) toast.error( res.data.err_msg )
                        }
                    })
                }
            },

            doSearchItem: () => {
                let params = {
                    idx: comp.selected.idx
                }
                axios.get("/ai/voice_list", { params:params }).then((res) => {
                    if( res.data.err == 0 ){
                        for(let i=0; i<comp.list.length; i++){
                            let irow = comp.list[i];

                            if( irow.idx == comp.selected.idx ){
                                irow.list = res.data.list;
                            }
                        }
                    }
                })
            },

            doDeselect:()=>{
                comp.selected.idx = ''
                comp.modified.idx = ''
                comp.modified.pron = ''
            },

            doModify: () => {
                let params = {
                    idx : comp.modified.idx,
                    text : comp.modified.script
                }
                if( !params.text || !(params.text.trim()) ){
                    toast.warning("스크립트를 입력해 주세요.")
                    return;
                }
                axios.post("/ai/sample_script_mod", params).then((res) => {
                    if( res.data.err == 0 ){
                        comp.doDeselect()
                        comp.doSearch()
                    } else {
                        if( res.data.err_msg ) toast.error( res.data.err_msg )
                    }
                });
            },

            doDelete:(idx)=>{
                let params = { idx:idx }
                if( confirm("삭제하시겠습니까?") == true ){
                    axios.get("/ai/sample_script_del", { params:params }).then((res) => {
                        if( res.data.err == 0 ){
                            comp.doSearch()
                        } else {
                            if( res.data.err_msg ) toast.error( res.data.err_msg )
                        }
                    })
                }
            },


            showView:(iv, jv)=>{
                if( jv.idx_pron_script == 12 )
                    comp.getRules(iv, jv)

                comp.view.idx = jv.idx
                comp.view.phonemes = iv.phonemes
                comp.view.control = iv.list
                comp.view.result = jv.result
                comp.view.text = iv.script
                comp.view.show = 'Y'

            },
            hideView:()=>{
                comp.view.show = 'N'
                comp.view.idx = ''
                comp.view.phonemes = []
                comp.view.control = []
                comp.view.result = []
                comp.view.text = ''
            },
            mkClass:(i)=>{
                let irow = comp.view.phonemes[i]
                return 'phonemes-' + i + ' ' + (!irow.grade?'':irow.grade)
            },

            selectNative:(idx)=>{
                console.log(idx)
                // if( comp.selected.control.indexOf(idx) > -1 ){
                //     comp.selected.control = comp.selected.control.splice(comp.selected.control.indexOf(idx), -1)
                // } else {
                //     comp.selected.control.push(idx)
                // }
                // console.log(comp.selected.control.indexOf(idx), comp.selected.control)
            },

            getRules: (o, target)=> {
                let src = o.list
                let control = []
                for(let i=0; i<src.length; i++){
                    let irow = src[i];
                    // if( irow.idx == target.idx ) continue;
                    if( irow.isnative == 'Y' )
                        control.push(irow.result)
                }

                // console.log(control)

                for(let i=0; i<target.result.length; i++){
                    let irow = target.result[i];
                    
                    let len = { min:100, max:0 };
                    let per = { min:100, max:0 };
                    for(let j=0; j<control.length; j++){
                        let jrow = control[j][i];
                        if( j == 0 ){
                            len.max = jrow.len
                            per.max = jrow.per
                        }

                        if( jrow.len < len.min ) len.min = jrow.len
                        if( len.max < jrow.len ) len.max = jrow.len

                        if( jrow.per < per.min ) per.min = jrow.per
                        if( per.max < jrow.per ) per.max = jrow.per
                    }

                    let x = (len.max - len.min)
                    if( len.min-(x*0.0) < irow.len && irow.len <= len.max+(x*0.0) ){
                        irow.score = 5
                    } else if( len.min-(x*1.0) < irow.len && irow.len <= len.max+(x*1.0) ){
                        irow.score = 4
                    } else if ( len.min-(x*1.5) < irow.len && irow.len <= len.max+(x*1.5) ){
                        irow.score = 3
                    } else if ( len.min-(x*2.0) < irow.len && irow.len <= len.max+(x*2.0) ){
                        irow.score = 2
                    } else {
                        irow.score = 1
                    }

                    target.result[i] = irow
                }

                let vert = { 'i':[ 'ay' ], 'test':[ 't', 'eh', 's', 'ch' ], 'you':['uw'] }
                for(let i=0; i<o.phonemes.length; i++){
                    let irow = o.phonemes[i]

                    let score = 0
                    let grade = ''
                    for(let j=0; j<target.result.length; j++){
                        let jrow = target.result[j]
                        // console.log(vert[irow.token], jrow.pron, vert[irow.token].indexOf(jrow.pron))
                        if( -1 < vert[irow.token].indexOf(jrow.pron) ){
                            // console.log(vert[irow.token], jrow.pron, vert[irow.token].indexOf(jrow.pron), jrow.score)
                            score += jrow.score
                        }
                    }

                    irow.total = score
                    score = Math.round(score/vert[irow.token].length)

                    switch(score){
                        case 5: grade = 'best'; break;
                        case 4: grade = 'good'; break;
                        case 3: grade = 'average'; break;
                        case 2: grade = 'fair'; break;
                        case 1: grade = 'poor'; break;
                    }

                    // console.log(irow.token, irow.total, score, grade)

                    irow.score = score
                    irow.grade = grade

                    o.phonemes[i] = irow
                }

                // console.log(o)
            }

        });

        onMounted(() => {
            comp.doSearch()

            comp.audioplayer = document.getElementById("audioplayer")
        });

        return { comp };
    }
}
</script>

<style lang="scss">
    @import "@/scss/_variables.scss";

    .rr-box {
        padding:10px 20px;

        .rr-text {
            width:calc(100% - 50px); float:left;
        }
        .rr-voice {
            width:1px; height:1px; opacity:0.01;
        }
        .btn-send {
            width:40px; height:40px; padding: 3px 10px; margin-top:10px; color: #FFF; border: 1px solid #ddd; border-radius: 50px; background-color: rgb(200, 200, 200); 
            &.active {
                background-color: rgb(122, 134, 238); 
            }
        }
    }
    .bar {
        position:relative; height:20px; padding:10px 0px; border-top:1px solid #c8c8c8; margin:20px 20px 0;
        span {
            position:absolute; top:-10px; left:0; right:0; width:130px; margin:0 auto; text-align:center; background-color:#f9f9f9; color:#999;
        }
    }

    .sample-list {
        padding:0 20px;
        .sample-item {
            position:relative; margin-bottom:5px; border-bottom:1px solid #c8c8c8; padding-bottom:5px;
            .title {
                display:block; text-align:left; height:inherit; color:#929292;
            }
            .sample-body {
                position:relative;
                width:calc(100% - 90px); height:40px; text-align:left; vertical-align:middle;
                display:flex;justify-content: center; align-items: center;
                .script {
                    position:absolute; left:0; vertical-align:middle; cursor:pointer;
                }
                .pronunciation {
                    position:relative; display:none; width:100%; height:40px; text-align:left;
                    .reum-textbox {
                        width:calc(100% - 80px); margin-top:-9px; display:inline-block;
                    }
                }
                button {
                    display:inline-block; width:40px; height:40px; 
                    padding:0; border: 1px solid #ddd; border-radius: 50%;
                    color: #FFF; font-size:1.4rem; text-align:center; margin-top:-1px;
                }
                .btn-submit {
                    background-color:rgb(132, 196, 49);
                }
                .btn-cancel {
                    background-color: rgb(240, 48, 48);
                }
            }
            > button {
                position:absolute; top:0; 
                width:40px; height:40px; padding:0;color: #FFF;
                border: 1px solid #ddd; border-radius: 50%; font-size:1.4rem; text-align:center;
            }
            .btn-play {
                width:30px; height:30px; right:30px; background-color:rgba(177, 214, 129, 0.7);
            }
            .btn-mod {
                display:block; right:42px; background-color:rgba(177, 214, 129, 0.7);
            }
            .btn-demod {
                display:none; right:42px; background-color:rgba(177, 214, 129, 0.7);
            }
            .btn-del {
                right:0px; background-color: rgb(255, 81, 81);
            }
            &.modified {
                .sample-body {
                    // display:block; height:inherit;
                }
                .script {
                    display:none;
                }
                .pronunciation {
                    display:block;
                }
                .voice-list {
                    // display:block;
                }
                .btn-mod {
                    display:none;
                }
                .btn-demod {
                    display:block;
                }
            }
            &.selected {
                .sample-body {
                    display:block; height:inherit;
                }
                .script {
                    position:inherit;
                }
                .pronunciation {
                    // display:block;
                }
                .voice-list {
                    display:block;
                }
                .btn-mod {
                    display:none;
                }
                .btn-demod {
                    display:block;
                }
            }
            &::after {
                display:block; content: ''; clear:both;
            }

            .voice-list {
                padding:10px 0; display:none;
                .phonemes {
                    padding:0px 0 10px;
                }
                .voice-item {
                    background-color:#dfdfdf; display:inline-block; padding:5px; border-radius:30px; margin-right:5px;
                    span {
                        padding:0 10px; cursor:pointer;
                    }
                    button {
                        width:30px; height:30px; padding:0; line-height:28px;
                        i::before {
                            line-height: 28px;;
                        }
                    }
                    .btn-play {
                        background-color:rgba(177, 214, 129, 0.7);
                    }
                    .btn-del {
                        background-color: rgb(255, 81, 81);
                    }
                    label {
                        cursor:pointer;
                    }
                    .checkbox {
                        width:20px; height:20px; margin-right:5px; cursor:pointer;
                    }

                    &.new {
                        .btn-audio {
                            background-color:rgba(177, 214, 129, 0.7);
                        }
                        .btn-rec {
                            background-color: rgb(238, 122, 122);
                        }
                        .btn-send {
                            background-color: rgb(122, 134, 238);
                        }
                    }
                }
            }
        }
    }


</style>
